import apiClient from '../../../api-client';
import { DefaultAttachment } from '../../interfaces/Attachments';

export class AttachmentService {
  public async getUploadUrl(
    filename: string,
    contentType: string,
    companyId: number
  ): Promise<string> {
    // Your API call to the backend method you showed earlier
    try {
      const response = await apiClient.post(
        `${process.env.GATSBY_SSO_BACKEND_API_URL}/backoffice/${companyId}/attachments`,
        { filename, contentType }
      );

      return response.data;
    } catch (error: any) {
      console.log(error);
      throw new Error(
        `error generating url: ${error.response?.statusText || error.message}`
      );
    }
  }

  public async getSignedUrl(companyId: number, filename: string) {
    try {
      const response = await apiClient.get(
        `${process.env.GATSBY_SSO_BACKEND_API_URL}/backoffice/${companyId}/attachments/${filename}`
      );

      return response.data;
    } catch (error: any) {
      console.log(error);
      throw new Error(
        `error generating url: ${error.response?.statusText || error.message}`
      );
    }
  }

  public async addAttachment(
    companyId: number,
    projectId: number,
    attachment: DefaultAttachment
  ) {
    try {
      const response = await apiClient.post(
        `${process.env.GATSBY_SSO_BACKEND_API_URL}/backoffice/${companyId}/projects/${projectId}/attachments`,
        { ...attachment }
      );

      return response.data;
    } catch (error: any) {
      console.log(error);
      throw new Error(
        `error generating url: ${error.response?.statusText || error.message}`
      );
    }
  }

  public async getProjectAttachments(companyId: number, projectId: number) {
    try {
      const response = await apiClient.get(
        `${process.env.GATSBY_SSO_BACKEND_API_URL}/backoffice/${companyId}/projects/${projectId}/attachments/`
      );

      return response.data;
    } catch (error: any) {
      console.log(error);
      throw new Error(
        `error generating url: ${error.response?.statusText || error.message}`
      );
    }
  }

  public async upload(
    signedUrl: string,
    file: File,
    contentType: string
  ): Promise<void> {
    const response = await fetch(signedUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': contentType,
      },
    });

    if (!response.ok) {
      throw new Error(`Upload failed with status: ${response.status}`);
    }
  }
}
